'use client';

import { usePathname } from 'next/navigation';
import { FeedbackWidget } from './FeedbackWidget';

export function FeedbackFab() {
  const pathname = usePathname();

  // Hide on admin/moderator pages
  if (pathname?.startsWith('/interactive') || pathname?.startsWith('/d9k2m') || pathname?.startsWith('/r7x4p')) return null;

  // Use pathname as page slug for feedback/FAQ scoping
  const pageSlug = pathname || '/';

  return <FeedbackWidget pageSlug={pageSlug} />;
}
